export const useOnChangePartial =
  <T>(setFormState: (generator: (state: T) => T) => void) =>
  (partialNextState: Partial<T>) =>
    setFormState((state) => ({
      ...state,
      ...partialNextState,
    }));
